import React from 'react'

const RealTimeTrack = () => {
    return (
        <>
           <svg
  xmlns="http://www.w3.org/2000/svg"
  version="1.1"
  xmlnsXlink="http://www.w3.org/1999/xlink"
  width={40}
  height={40}
  x={0}
  y={0}
  viewBox="0 0 36 36"
  style={{ enableBackground: "new 0 0 512 512" }}
  xmlSpace="preserve"
  className=""
>
  <g>
    <g fillRule="evenodd">
      <path
        fill="#072a30"
        d="M22.85 9.72c-2.68-2.68-7.02-2.68-9.7 0s-2.68 7.02 0 9.7 7.02 2.68 9.7 0 2.68-7.02 0-9.7zm-2.9 6.8c-.45.45-1.17.45-1.62 0l-1.14-1.14a1.16 1.16 0 0 1-.33-.81v-2.29a1.14 1.14 0 1 1 2.28 0v1.81l.81.81c.45.45.45 1.17 0 1.62z"
        opacity={1}
        data-original="#072a30"
        className=""
      />
      <path
        fill="#43d685"
        d="M18 2C11.06 2 5.43 7.63 5.43 14.57 5.43 27.48 18 34 18 34s12.57-6.52 12.57-19.43C30.57 7.63 24.94 2 18 2zm-6.46 19.04A9.144 9.144 0 0 1 24.47 8.11a9.144 9.144 0 0 1-12.93 12.93z"
        opacity={1}
        data-original="#43d685"
      />
    </g>
  </g>
</svg>

        </>
    )
}

export default RealTimeTrack